import { HostConfig } from './host-config';
import { Panel } from './panel';

export interface HostPanel extends Panel {
  config: HostConfig;
  panelStyle: any;
  maximized?: boolean;
}
